import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ServiceRoute from 'routes/route'
import ErrorPage from 'containers/pages/ErrorPage'

export function NotFound() {
  return (
    <Status code={404}>
      <div />
    </Status>
  )
}

function Status({ code, children }) {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) staticContext.status = code
        return children
      }}
    />
  )
}

export function routeIndexes(service) {
  const indexes = {
    account: ServiceRoute,
  }
  return indexes[service]
}

export function serviceRouter(service, ssr = true, errorStatus = null) {
  return function() {
    return (
      <Switch>
        {ServiceRoute.map((route, index) => (
          <Route key={index} {...route} />
        ))}
        {ssr ? (
          <Route component={NotFound} />
        ) : (
          <ErrorPage status={errorStatus} />
        )}
      </Switch>
    )
  }
}
